import { createSlice } from "@reduxjs/toolkit";
import { Get } from "../../config/apiMethod";

export const boardSlice = createSlice({
  name: "authLogin",
  initialState: null,
  reducers: {
    setBoardDetails: (state, action) => {
      state = action.payload;
    },
  },
});

export const { setBoardDetails } = boardSlice.actions;

export const getCardDetails = () => async (dispatch) => {

  //   const trelloToken = localStorage.getItem("trelloToken");
  // if (trelloToken) {
  //   const randomString = Math.random().toString(36).substring(2, 5);
  //   let response = await Get(`board/v1/board-lists?cache=${randomString}`, null, {});
  //   console.log("fetchLoginDetails",response);
    
  //   if (response.status === 200) {
  //       console.log("boardLists",response);


  //   }
  // } else {
  //   dispatch(setBoardDetails(null));
  // }
};

export default boardSlice.reducer;
